﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleType = exports.Vehicle = exports.UserShort = exports.UserPublicInfo = exports.User = exports.UpdateVehicleRequest = exports.UpdateUserRequest = exports.UpdateUserInfoRequest = exports.UpdateUserEmailRequest = exports.Size = exports.Route = exports.ResultFail = exports.RateArea = exports.Rate = exports.OrderRequest = exports.OrderPriceChange = exports.OrderExtended = exports.OrderChange = exports.Order = exports.NotificationMessage = exports.Location = exports.LocalizedString = exports.HotMessage = exports.FileDescriptor = exports.DriverRequest = exports.DriverFull = exports.Driver = exports.CreateVehicleTypeRequest = exports.CreateVehicleRequest = exports.CreateRateAreaRequest = exports.CreatePreOrderRequest = exports.Coordinates = exports.CompanyRequest = exports.Company = exports.ChangePriceOrderRequest = exports.Authenticator = exports.AuthToken = exports.AuthSession = exports.ActiveVehicleFull = exports.ActiveVehicle = exports.Access = void 0;
const net = require("@ivanlog/net");
class Access extends net.Model {
    constructor(initObj = {}) {
        super("Access");
        this.type = net.def.argString("type", initObj);
        this.data = net.def.argString("data", initObj);
        this.untilTime = net.def.argDate("untilTime", initObj);
    }
}
exports.Access = Access;
class ActiveVehicle extends net.Model {
    constructor(initObj = {}) {
        super("ActiveVehicle");
        this.vehicleId = net.def.argInt("vehicleId", initObj);
        this.driverId = net.def.argInt("driverId", initObj);
        this.vehicleTypeId = net.def.argInt("vehicleTypeId", initObj);
        this.activeOrderId = net.def.argInt("activeOrderId", initObj);
        this.portersCount = net.def.argInt("portersCount", initObj);
        this.lastUpdate = net.def.argDate("lastUpdate", initObj);
        this.coordinates = new Coordinates(net.def.argSearch("coordinates", initObj));
        this.state = net.def.argString("state", initObj);
        this.currentRoute = new Route(net.def.argSearch("currentRoute", initObj));
        this.isRestoredState = net.def.argBool("isRestoredState", initObj);
    }
}
exports.ActiveVehicle = ActiveVehicle;
class ActiveVehicleFull extends net.Model {
    constructor(initObj = {}) {
        super("ActiveVehicleFull");
        this.vehicle = new Vehicle(net.def.argSearch("vehicle", initObj));
        this.driver = new Driver(net.def.argSearch("driver", initObj));
        this.driverUser = new UserShort(net.def.argSearch("driverUser", initObj));
        this.activeOrderId = net.def.argInt("activeOrderId", initObj);
        this.lastUpdate = net.def.argDate("lastUpdate", initObj);
        this.coordinates = new Coordinates(net.def.argSearch("coordinates", initObj));
        this.state = net.def.argString("state", initObj);
        this.currentRoute = new Route(net.def.argSearch("currentRoute", initObj));
    }
}
exports.ActiveVehicleFull = ActiveVehicleFull;
class AuthSession extends net.Model {
    constructor(initObj = {}) {
        super("AuthSession");
        this.sid = net.def.argString("sid", initObj);
    }
}
exports.AuthSession = AuthSession;
class AuthToken extends net.Model {
    constructor(initObj = {}) {
        super("AuthToken");
        this.userId = net.def.argInt("userId", initObj);
        this.created = net.def.argInt("created", initObj);
        this.until = net.def.argInt("until", initObj);
        this.sign = net.def.argString("sign", initObj);
    }
}
exports.AuthToken = AuthToken;
class Authenticator extends net.Model {
    constructor(initObj = {}) {
        super("Authenticator");
        this.authType = net.def.argString("authType", initObj);
        this.data = net.def.argString("data", initObj);
        this.confirmed = net.def.argBool("confirmed", initObj);
    }
}
exports.Authenticator = Authenticator;
class ChangePriceOrderRequest extends net.Model {
    constructor(initObj = {}) {
        super("ChangePriceOrderRequest");
        this.orderId = net.def.argInt("orderId", initObj);
        this.priceDelta = net.def.argFloat("priceDelta", initObj);
        this.reason = net.def.argString("reason", initObj);
    }
}
exports.ChangePriceOrderRequest = ChangePriceOrderRequest;
class Company extends net.Model {
    constructor(initObj = {}) {
        super("Company");
        this.id = net.def.argInt("id", initObj);
        this.created = net.def.argDate("created", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.name = net.def.argString("name", initObj);
        this.shortName = net.def.argString("shortName", initObj);
        this.vatNumber = net.def.argString("vatNumber", initObj);
        this.legalAddress = net.def.argString("legalAddress", initObj);
        this.ceo = net.def.argString("ceo", initObj);
        this.iban = net.def.argString("iban", initObj);
        this.contactPhone = net.def.argString("contactPhone", initObj);
        this.contactEmail = net.def.argString("contactEmail", initObj);
        this.companyData = net.def.argString("companyData", initObj);
    }
}
exports.Company = Company;
class CompanyRequest extends net.Model {
    constructor(initObj = {}) {
        super("CompanyRequest");
        this.name = net.def.argString("name", initObj);
        this.shortName = net.def.argString("shortName", initObj);
        this.companyData = net.def.argString("companyData", initObj);
        this.vatNumber = net.def.argString("vatNumber", initObj);
        this.legalAddress = net.def.argString("legalAddress", initObj);
        this.ceo = net.def.argString("ceo", initObj);
        this.iban = net.def.argString("iban", initObj);
        this.contactPhone = net.def.argString("contactPhone", initObj);
        this.contactEmail = net.def.argString("contactEmail", initObj);
    }
}
exports.CompanyRequest = CompanyRequest;
class Coordinates extends net.Model {
    constructor(initObj = {}) {
        super("Coordinates");
        this.lng = net.def.argFloat("lng", initObj);
        this.lat = net.def.argFloat("lat", initObj);
    }
}
exports.Coordinates = Coordinates;
class CreatePreOrderRequest extends net.Model {
    constructor(initObj = {}) {
        super("CreatePreOrderRequest");
        this.vehicleTypeId = net.def.argInt("vehicleTypeId", initObj);
        this.routeId = net.def.argString("routeId", initObj);
        this.portersCount = net.def.argInt("portersCount", initObj);
        this.paymentProvider = net.def.argString("paymentProvider", initObj);
        this.paymentMethodId = net.def.argString("paymentMethodId", initObj);
        this.clientComment = net.def.argString("clientComment", initObj);
    }
}
exports.CreatePreOrderRequest = CreatePreOrderRequest;
class CreateRateAreaRequest extends net.Model {
    constructor(initObj = {}) {
        super("CreateRateAreaRequest");
        this.name = net.def.argString("name", initObj);
        this.coordinates = [];
        const tempcoordinates = net.def.argSearch("coordinates", initObj);
        if (tempcoordinates)
            tempcoordinates.forEach(obj => this.coordinates.push(new Coordinates(obj)));
    }
}
exports.CreateRateAreaRequest = CreateRateAreaRequest;
class CreateVehicleRequest extends net.Model {
    constructor(initObj = {}) {
        super("CreateVehicleRequest");
        this.typeId = net.def.argInt("typeId", initObj);
        this.govNumber = net.def.argString("govNumber", initObj);
        this.model = net.def.argString("model", initObj);
        this.color = net.def.argString("color", initObj);
        this.vehicleData = net.def.argString("vehicleData", initObj);
    }
}
exports.CreateVehicleRequest = CreateVehicleRequest;
class CreateVehicleTypeRequest extends net.Model {
    constructor(initObj = {}) {
        super("CreateVehicleTypeRequest");
        this.name = new LocalizedString(net.def.argSearch("name", initObj));
        this.size = new Size(net.def.argSearch("size", initObj));
        this.volume = net.def.argFloat("volume", initObj);
        this.payload = net.def.argInt("payload", initObj);
        this.description = new LocalizedString(net.def.argSearch("description", initObj));
        this.descriptionShort = new LocalizedString(net.def.argSearch("descriptionShort", initObj));
        this.iconFile = net.def.argString("iconFile", initObj);
    }
}
exports.CreateVehicleTypeRequest = CreateVehicleTypeRequest;
class Driver extends net.Model {
    constructor(initObj = {}) {
        super("Driver");
        this.userId = net.def.argInt("userId", initObj);
        this.driverLicense = net.def.argString("driverLicense", initObj);
    }
}
exports.Driver = Driver;
class DriverFull extends net.Model {
    constructor(initObj = {}) {
        super("DriverFull");
        this.userShort = new UserShort(net.def.argSearch("userShort", initObj));
        this.driver = new Driver(net.def.argSearch("driver", initObj));
        this.linkedVehicles = [];
        const templinkedVehicles = net.def.argSearch("linkedVehicles", initObj);
        if (templinkedVehicles)
            templinkedVehicles.forEach(obj => this.linkedVehicles.push(new Vehicle(obj)));
        this.company = new Company(net.def.argSearch("company", initObj));
    }
}
exports.DriverFull = DriverFull;
class DriverRequest extends net.Model {
    constructor(initObj = {}) {
        super("DriverRequest");
        this.userId = net.def.argInt("userId", initObj);
        this.driverLicense = net.def.argString("driverLicense", initObj);
    }
}
exports.DriverRequest = DriverRequest;
class FileDescriptor extends net.Model {
    constructor(initObj = {}) {
        super("FileDescriptor");
        this.id = net.def.argString("id", initObj);
        this.hash = net.def.argString("hash", initObj);
        this.category = net.def.argString("category", initObj);
        this.type = net.def.argString("type", initObj);
        this.mime = net.def.argString("mime", initObj);
        this.created = net.def.argDate("created", initObj);
        this.attributes = net.def.argString("attributes", initObj);
    }
}
exports.FileDescriptor = FileDescriptor;
class HotMessage extends net.Model {
    constructor(initObj = {}) {
        super("HotMessage");
        this.pushId = net.def.argInt("pushId", initObj);
        this.dateTime = net.def.argDate("dateTime", initObj);
        this.type = net.def.argString("type", initObj);
        this.messageJSON = net.def.argString("messageJSON", initObj);
    }
}
exports.HotMessage = HotMessage;
class LocalizedString extends net.Model {
    constructor(initObj = {}) {
        super("LocalizedString");
        this.en = net.def.argString("en", initObj);
        this.de = net.def.argString("de", initObj);
    }
}
exports.LocalizedString = LocalizedString;
class Location extends net.Model {
    constructor(initObj = {}) {
        super("Location");
        this.googlePlaceId = net.def.argString("googlePlaceId", initObj);
        this.coordinates = new Coordinates(net.def.argSearch("coordinates", initObj));
        this.addressFull = net.def.argString("addressFull", initObj);
    }
}
exports.Location = Location;
class NotificationMessage extends net.Model {
    constructor(initObj = {}) {
        super("NotificationMessage");
        this.id = net.def.argInt("id", initObj);
        this.forUserId = net.def.argInt("forUserId", initObj);
        this.typeId = net.def.argInt("typeId", initObj);
        this.caption = net.def.argString("caption", initObj);
        this.text = net.def.argString("text", initObj);
        this.reasonId = net.def.argString("reasonId", initObj);
        this.isViewed = net.def.argBool("isViewed", initObj);
        this.created = net.def.argDate("created", initObj);
    }
}
exports.NotificationMessage = NotificationMessage;
class Order extends net.Model {
    constructor(initObj = {}) {
        super("Order");
        this.id = net.def.argInt("id", initObj);
        this.isActive = net.def.argBool("isActive", initObj);
        this.created = net.def.argDate("created", initObj);
        this.updated = net.def.argDate("updated", initObj);
        this.state = net.def.argString("state", initObj);
        this.customerId = net.def.argInt("customerId", initObj);
        this.driverId = net.def.argInt("driverId", initObj);
        this.vehicleId = net.def.argInt("vehicleId", initObj);
        this.vehicleTypeId = net.def.argInt("vehicleTypeId", initObj);
        this.rateId = net.def.argInt("rateId", initObj);
        this.startTime = net.def.argDate("startTime", initObj);
        this.endTime = net.def.argDate("endTime", initObj);
        this.startTimeInFact = net.def.argDate("startTimeInFact", initObj);
        this.endTimeInFact = net.def.argDate("endTimeInFact", initObj);
        this.route = new Route(net.def.argSearch("route", initObj));
        this.portersCount = net.def.argInt("portersCount", initObj);
        this.estimatedPrice = net.def.argFloat("estimatedPrice", initObj);
        this.finalPrice = net.def.argFloat("finalPrice", initObj);
        this.finalCheck = net.def.argString("finalCheck", initObj);
        this.clientComment = net.def.argString("clientComment", initObj);
        this.changes = [];
        const tempchanges = net.def.argSearch("changes", initObj);
        if (tempchanges)
            tempchanges.forEach(obj => this.changes.push(new OrderChange(obj)));
        this.priceChanges = [];
        const temppriceChanges = net.def.argSearch("priceChanges", initObj);
        if (temppriceChanges)
            temppriceChanges.forEach(obj => this.priceChanges.push(new OrderPriceChange(obj)));
        this.paymentProvider = net.def.argString("paymentProvider", initObj);
        this.paymentMethodId = net.def.argString("paymentMethodId", initObj);
    }
}
exports.Order = Order;
class OrderChange extends net.Model {
    constructor(initObj = {}) {
        super("OrderChange");
        this.id = net.def.argInt("id", initObj);
        this.orderId = net.def.argInt("orderId", initObj);
        this.byUserId = net.def.argInt("byUserId", initObj);
        this.created = net.def.argDate("created", initObj);
        this.state = net.def.argString("state", initObj);
        this.comment = net.def.argString("comment", initObj);
    }
}
exports.OrderChange = OrderChange;
class OrderExtended extends net.Model {
    constructor(initObj = {}) {
        super("OrderExtended");
        this.order = new Order(net.def.argSearch("order", initObj));
        this.customer = new UserPublicInfo(net.def.argSearch("customer", initObj));
        this.driver = new UserPublicInfo(net.def.argSearch("driver", initObj));
        this.vehicle = new Vehicle(net.def.argSearch("vehicle", initObj));
        this.vehicleType = new VehicleType(net.def.argSearch("vehicleType", initObj));
    }
}
exports.OrderExtended = OrderExtended;
class OrderPriceChange extends net.Model {
    constructor(initObj = {}) {
        super("OrderPriceChange");
        this.id = net.def.argInt("id", initObj);
        this.orderId = net.def.argInt("orderId", initObj);
        this.byUserId = net.def.argInt("byUserId", initObj);
        this.created = net.def.argDate("created", initObj);
        this.reason = net.def.argString("reason", initObj);
        this.priceChange = net.def.argFloat("priceChange", initObj);
    }
}
exports.OrderPriceChange = OrderPriceChange;
class OrderRequest extends net.Model {
    constructor(initObj = {}) {
        super("OrderRequest");
        this.orderId = net.def.argInt("orderId", initObj);
        this.comment = net.def.argString("comment", initObj);
    }
}
exports.OrderRequest = OrderRequest;
class Rate extends net.Model {
    constructor(initObj = {}) {
        super("Rate");
        this.id = net.def.argInt("id", initObj);
        this.refRateId = net.def.argInt("refRateId", initObj);
        this.created = net.def.argDate("created", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.name = net.def.argString("name", initObj);
        this.description = new LocalizedString(net.def.argSearch("description", initObj));
        this.rateAreaId = net.def.argInt("rateAreaId", initObj);
        this.forVehicleTypesId = net.def.argSearch("forVehicleTypesId", initObj);
        if (!this.forVehicleTypesId)
            this.forVehicleTypesId = [];
        this.freeWaitingTimeMin = net.def.argInt("freeWaitingTimeMin", initObj);
        this.priceBase = net.def.argFloat("priceBase", initObj);
        this.priceEachKm = net.def.argFloat("priceEachKm", initObj);
        this.priceAdditionalStop = net.def.argFloat("priceAdditionalStop", initObj);
        this.priceOvertimeWaitingEach5Min = net.def.argFloat("priceOvertimeWaitingEach5Min", initObj);
        this.priceWeekendHoliday = net.def.argFloat("priceWeekendHoliday", initObj);
        this.pricePorter = net.def.argFloat("pricePorter", initObj);
    }
}
exports.Rate = Rate;
class RateArea extends net.Model {
    constructor(initObj = {}) {
        super("RateArea");
        this.id = net.def.argInt("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.polygon = [];
        const temppolygon = net.def.argSearch("polygon", initObj);
        if (temppolygon)
            temppolygon.forEach(obj => this.polygon.push(new Coordinates(obj)));
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.RateArea = RateArea;
class ResultFail extends net.Model {
    constructor(initObj = {}) {
        super("ResultFail");
        this.actionCode = net.def.argString("actionCode", initObj);
        this.message = net.def.argString("message", initObj);
        this.description = net.def.argString("description", initObj);
    }
}
exports.ResultFail = ResultFail;
class Route extends net.Model {
    constructor(initObj = {}) {
        super("Route");
        this.id = net.def.argString("id", initObj);
        this.locations = [];
        const templocations = net.def.argSearch("locations", initObj);
        if (templocations)
            templocations.forEach(obj => this.locations.push(new Location(obj)));
        this.estimatedTimeTotalSec = net.def.argInt("estimatedTimeTotalSec", initObj);
        this.estimatedLengthKm = net.def.argFloat("estimatedLengthKm", initObj);
        this.departureTime = net.def.argDate("departureTime", initObj);
    }
}
exports.Route = Route;
class Size extends net.Model {
    constructor(initObj = {}) {
        super("Size");
        this.width = net.def.argInt("width", initObj);
        this.length = net.def.argInt("length", initObj);
        this.height = net.def.argInt("height", initObj);
    }
}
exports.Size = Size;
class UpdateUserEmailRequest extends net.Model {
    constructor(initObj = {}) {
        super("UpdateUserEmailRequest");
        this.userId = net.def.argInt("userId", initObj);
        this.email = net.def.argString("email", initObj);
    }
}
exports.UpdateUserEmailRequest = UpdateUserEmailRequest;
class UpdateUserInfoRequest extends net.Model {
    constructor(initObj = {}) {
        super("UpdateUserInfoRequest");
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.userData = net.def.argString("userData", initObj);
    }
}
exports.UpdateUserInfoRequest = UpdateUserInfoRequest;
class UpdateUserRequest extends net.Model {
    constructor(initObj = {}) {
        super("UpdateUserRequest");
        this.userId = net.def.argInt("userId", initObj);
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.userData = net.def.argString("userData", initObj);
    }
}
exports.UpdateUserRequest = UpdateUserRequest;
class UpdateVehicleRequest extends net.Model {
    constructor(initObj = {}) {
        super("UpdateVehicleRequest");
        this.vehicleId = net.def.argInt("vehicleId", initObj);
        this.vehicleData = net.def.argString("vehicleData", initObj);
    }
}
exports.UpdateVehicleRequest = UpdateVehicleRequest;
class User extends net.Model {
    constructor(initObj = {}) {
        super("User");
        this.id = net.def.argInt("id", initObj);
        this.created = net.def.argDate("created", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.createdByUserId = net.def.argInt("createdByUserId", initObj);
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.photoFile = net.def.argString("photoFile", initObj);
        this.userData = net.def.argString("userData", initObj);
        this.language = net.def.argString("language", initObj);
        this.auths = [];
        const tempauths = net.def.argSearch("auths", initObj);
        if (tempauths)
            tempauths.forEach(obj => this.auths.push(new Authenticator(obj)));
        this.accesses = [];
        const tempaccesses = net.def.argSearch("accesses", initObj);
        if (tempaccesses)
            tempaccesses.forEach(obj => this.accesses.push(new Access(obj)));
    }
}
exports.User = User;
class UserPublicInfo extends net.Model {
    constructor(initObj = {}) {
        super("UserPublicInfo");
        this.id = net.def.argInt("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.phone = net.def.argString("phone", initObj);
        this.language = net.def.argString("language", initObj);
    }
}
exports.UserPublicInfo = UserPublicInfo;
class UserShort extends net.Model {
    constructor(initObj = {}) {
        super("UserShort");
        this.id = net.def.argInt("id", initObj);
        this.name = net.def.argString("name", initObj);
        this.surname = net.def.argString("surname", initObj);
        this.photoFile = net.def.argString("photoFile", initObj);
        this.language = net.def.argString("language", initObj);
        this.accesses = [];
        const tempaccesses = net.def.argSearch("accesses", initObj);
        if (tempaccesses)
            tempaccesses.forEach(obj => this.accesses.push(new Access(obj)));
    }
}
exports.UserShort = UserShort;
class Vehicle extends net.Model {
    constructor(initObj = {}) {
        super("Vehicle");
        this.id = net.def.argInt("id", initObj);
        this.created = net.def.argDate("created", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
        this.vehicleTypeId = net.def.argInt("vehicleTypeId", initObj);
        this.govNumber = net.def.argString("govNumber", initObj);
        this.model = net.def.argString("model", initObj);
        this.color = net.def.argString("color", initObj);
        this.vehicleData = net.def.argString("vehicleData", initObj);
    }
}
exports.Vehicle = Vehicle;
class VehicleType extends net.Model {
    constructor(initObj = {}) {
        super("VehicleType");
        this.id = net.def.argInt("id", initObj);
        this.name = new LocalizedString(net.def.argSearch("name", initObj));
        this.size = new Size(net.def.argSearch("size", initObj));
        this.volume = net.def.argFloat("volume", initObj);
        this.payload = net.def.argInt("payload", initObj);
        this.description = new LocalizedString(net.def.argSearch("description", initObj));
        this.descriptionShort = new LocalizedString(net.def.argSearch("descriptionShort", initObj));
        this.iconFile = net.def.argString("iconFile", initObj);
        this.isDeleted = net.def.argBool("isDeleted", initObj);
    }
}
exports.VehicleType = VehicleType;
//# sourceMappingURL=models.js.map